<template>
  <base-tabs-view
    :tabs="Tabs"
  />
</template>

<script>
import BaseTabsView from '@/components/shared/base/base-tabs-view'
import BaseTabsViewMixin from '@/mixins/base-tabs-view-mixin'

export default {
  name: 'Families',
  components: {
    BaseTabsView
  },
  mixins: [
    BaseTabsViewMixin
  ],
  computed: {
    Tabs () {
      return [
        {
          component: 'families-overview',
          idComponent: this.constantMixin.menuItem.families.general,
          name: this.TextMixin_GetTab('overview')
        },
        {
          component: 'families-detail',
          disabled: !this.ContentMixin_Element,
          idComponent: this.constantMixin.menuItem.families.general,
          name: this.TextMixin_GetTab(this.BaseTabsViewMixin_GetDetailsTab(), this.TextMixin_GetParameter('family'))
        },
        {
          component: 'families-children',
          disabled: this.BaseTabsViewMixin_DisableIfNew,
          idComponent: this.constantMixin.menuItem.families.children,
          name: this.TextMixin_GetTab('children')
        },
        {
          component: 'families-documents',
          disabled: this.BaseTabsViewMixin_DisableIfNew,
          idComponent: this.constantMixin.menuItem.families.documents,
          name: this.TextMixin_GetTab('documents')
        },
        {
          component: 'families-requests',
          disabled: this.BaseTabsViewMixin_DisableIfNew,
          idComponent: this.constantMixin.menuItem.families.requests,
          name: this.TextMixin_GetTab('requests')
        },
        {
          component: 'families-bank-statements',
          disabled: this.BaseTabsViewMixin_DisableIfNew,
          idComponent: this.constantMixin.menuItem.families.bankStatements,
          name: this.TextMixin_GetTab('bankStatements')
        }
      ]
    }
  }
}
</script>
